import { useEffect, useState } from "react";
import api from "../api/api";
import "../components/table.css";
import Pagination from "../components/Pagination";
import BackButton from "../components/BackButton";
import Table from "../components/table";
import usePagination from "../utils/usePagination";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { Link } from "react-router-dom";
 
const ChaRequests = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(enquiries, 5);
 
  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await api("/cha/all-requests");
        setEnquiries(response.data.requests);
        console.log(response.data.requests);
      } catch (error) {
        console.error("Failed to fetch cha requests:", error);
        setEnquiries([]);
      } finally {
        setLoading(false);
      }
    };
 
    fetchEnquiries();
  }, []);
 
  const columns = [
    { label: "Enquiry No", accessor: "enq_id" },
    {
      label: "POL",
      accessor: "pol",
    },
    { label: "POD", accessor: "pod" },
    { label: "Status", accessor: "Status" },
    { label: "HS Code", accessor: "hs_code" },
    { label: "Nature Of Cargo", accessor: "nature_of_cargo" },
    {
      label: "Action",
      render: (request) => (
        <div className="d-flex justify-content-center">
          <Link
            to={`/cha-services/view/${request.enq_id}`}
            title="View Request"
          >
            <PostAddIcon style={{ fontSize: 20 }} />
          </Link>
         
        </div>
      ),
    },
  ];
  return (
    <>
      {loading ? (
        <p>Loading ChaRequests...</p>
      ) : (
        <>
          <BackButton />
          <Table
            columns={columns}
            data={currentItems}
            loading={loading}
            emptyMessage="No CHA Requests Found"
            itemsPerPage={itemsPerPage}
            pagination={
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={goToPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                totalItems={totalItems}
              />
            }
          />
        </>
      )}
    </>
  );
};
export default ChaRequests;
 